import { AnyAction } from 'redux';
export const initialState = {
    layout: {},
};
export function reducer(state = initialState.layout, action: AnyAction) {
    switch (action.type) {
        default:
            return state;
    }
}
